


// import React, { useEffect, useState } from 'react';
// import image1 from '../img/logo/New folder/IMG-20241127-WA0001.jpg'; 
// import image2 from '../img/logo/New folder/IMG-20241127-WA0003.jpg'; 
// import image3 from '../img/logo/New folder/IMG-20241127-WA0002 (1).jpg';
// import { FaLinkedin, FaArrowLeft, FaArrowRight, FaQuoteLeft } from 'react-icons/fa'; // Import the quote icon
// import { borderLeftColor, fontFamily, maxWidth } from '@mui/system';
// import "./Newtestmonial.css";
// const Testimonial = () => {
//   const [activeIndex, setActiveIndex] = useState(0);
//   const testimonials = [
//     {
//       image: image1,
//       text: "As a trainer with 6 years of expertise in Virtual Robotics, my passion lies in bridging the gap between theoretical concepts and practical applications. My career has focused on developing robotic simulations, programming, and integrating advanced tools to design intelligent systems. I ensure that my trainees gain hands-on experience in creating real-world robotic models, preparing them for a future where automation and robotics redefine the industry landscape evolving field of robotics and automation.",
//       name: "G. Lokesh",
//       designation: " Automation Training Specialist",
//       linkedin: "https://www.linkedin.com/in/md-ghouse",
//     },
//     {
//       image: image2,
//       text: "With 15 years of extensive experience in Tools and Fixture Design, I bring a wealth of knowledge to every training session. My expertise lies in designing innovative tools and fixtures that align with industry standards, improving manufacturing accuracy, and reducing downtime. My sessions are structured to provide insights into problem-solving, 2D layout studies, and quality control measures, ensuring that learners leave with practical skills they can immediately apply in their careers practical skills they can immediately..",
//       name: "Riyaz Uddin",
//       designation: "Subject Matter Expert",
//       linkedin: "https://www.linkedin.com/in/saritha-komandla",
//     },
//     {
//       image: image3,
//       text: "With over 5 years of experience in the field of Digital Facility Solutions, I specialize in transforming traditional industrial processes into smart, efficient, and automated systems. My journey in this domain has been marked by implementing cutting-edge technologies and guiding teams in adopting digital solutions that enhance productivity and reduce operational costs. Training with me means diving deep into the core of digital facility design, understanding parametric modeling, and mastering innovative.",
//       name: "MD. Ghouse",
//       designation: "Technical Trainer",
//       linkedin: "https://www.linkedin.com/in/thirumal-rao",
//     },
//   ];

//   useEffect(() => {
//     const interval = setInterval(() => {
//       setActiveIndex((prevIndex) => (prevIndex + 1) % testimonials.length);
//     }, 3000); // Change every 3 seconds

//     return () => clearInterval(interval);
//   }, [testimonials.length]);

//   const containerStyle = {
//     display: 'flex',
//     justifyContent: 'center',
//     alignItems: 'center',
//     padding: '20px',
//     overflow: 'hidden',
//     position: 'relative',
//     marginTop: '132px',
//     transition: 'all 0.3s ease',
//     height: '686px',

//   };

//   const styles = {
//     title: {
//       textAlign: 'center',
//       fontFamily: 'Roboto, sans-serif',
//       fontWeight: 700,
//       fontSize: '48px',
//       marginBottom: '-100px',
//       marginTop: '60px',
//     },
//     titleBlack: {
//       color: 'black',
//     },
//     titleOrange: {
//       color: 'orange',
//     },
//   };

//   const cardStyle = {
//     position: 'relative',
//     transition: 'transform 0.3s ease-in-out',
//     maxWidth: '400px',
//     textAlign: 'center',
//     backgroundColor: '#ffffff',
//     borderRadius: '10px',
//     padding: '20px',
//     margin: '0 20px',
//     boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
//     borderWidth: '2px',
//     borderStyle: 'solid',
//     borderColor: '#029aa0',
//   };

//   const activeCardStyle = {
//     ...cardStyle,
//     transform: 'scale(1.1)', // Enlarge the center card
//   };

//   const imageStyle = {
//     width: '130px',
//     height: '130px',
//     borderRadius: '50%',
//     marginBottom: '10px',
//     border: '2px solid #029aa0',
//     transition: 'transform 0.3s ease',
//     marginTop: '-117px',
//     position: 'relative',
//   };

//   const textStyle = {
//     fontSize: '14px',
//     color: '#000',
//     lineHeight: '1.6',
//     marginBottom: '15px',
//     marginTop:'40px',
//   };

//   const buttonWrapperStyle = {
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'center',
//     marginTop: '10px',

//   };

//   const iconStyle = {
//     fontSize: '20px',
//     color: '#0077b5',
//     marginRight: '8px',
//   };

//   const buttonStyle = {
//     display: 'inline-block',
//     padding: '10px 15px',
//     fontSize: '14px',
//     fontWeight: 'bold',
//     color: '#ffffff',
//     backgroundColor: '#029aa0',
//     border: 'none',
//     borderRadius: '50px',

//     textDecoration: 'none',
//     cursor: 'pointer',
//     transition: 'background-color 0.3s ease',
//   };

//   const buttonHoverStyle = {
//     backgroundColor: '#005582',
//   };

//   const quoteIconStyle = {
//     color: '#029aa0', // Color of the quote icon
//     fontSize: '20px', // Larger font size for better visibility
//     position: 'absolute', // Positioning it absolutely
//     top: '20px', // Adjust for positioning above the image
//     zIndex: 1, // Ensure it appears above other content
//   };

//   const leftQuoteIconStyle = {
//     ...quoteIconStyle,
//     left: '20px', // Positioning to the left of the image
//   };

//   const rightQuoteIconStyle = {
//     ...quoteIconStyle,
//     right: '20px', // Positioning to the right of the image
//   };

//   const designationStyle = {
//     fontSize: '25px',
//     color: '#888',
//     marginTop: '10px',
//     fontFamily: 'roboto',
//   };

//   return (
//     <div>
//       <h1 style={styles.title}>
//         <span style={styles.titleBlack}>What Our</span>{' '}
//         <span style={styles.titleOrange}>Trainers Say</span>
//       </h1>
//       <div style={containerStyle}>
//         {testimonials.map((testimonial, index) => (
//           <div
//             key={index}
//             style={index === activeIndex ? activeCardStyle : cardStyle}
//           >
//             <div style={{ position: 'relative' }}>
//               {/* Left quote icon */}
//               <FaQuoteLeft style={leftQuoteIconStyle} />
//               {/* Image */}
//               <img
//                 src={testimonial.image}
//                 alt={testimonial.name}
//                 style={imageStyle}
//               />
//               {/* Right quote icon */}
//               <FaQuoteLeft style={rightQuoteIconStyle} />
//             </div>
//             <p style={textStyle}>{testimonial.text}</p>
//             <div style={buttonWrapperStyle}>
//               <a
//                 href={testimonial.linkedin}
//                 target="_blank"
//                 rel="noopener noreferrer"
//                 style={{ textDecoration: 'none' }}
//               >
//                 <FaLinkedin style={iconStyle} />
//               </a>
//               <span style={buttonStyle}>{testimonial.name}</span>
//             </div>
//             <p style={designationStyle}>{testimonial.designation}</p>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default Testimonial;




// import React from 'react';
// import OwlCarousel from 'react-owl-carousel';
// import image1 from '../img/logo/New folder/IMG-20241127-WA0001.jpg';
// import image2 from '../img/logo/New folder/IMG-20241127-WA0003.jpg';
// import image3 from '../img/logo/New folder/IMG-20241127-WA0002 (1).jpg';
// import { FaLinkedin, FaQuoteLeft } from 'react-icons/fa';
// import 'owl.carousel/dist/assets/owl.carousel.css';
// import 'owl.carousel/dist/assets/owl.theme.default.css';

// import { useNavigate } from 'react-router-dom';

// const Testimonial = () => {

//   const testimonials = [
//     {
//       image: image1,
//       text: "With over 5 years of experience in the field of Digital Facility Solutions, I specialize in transforming traditional industrial processes into smart, efficient, and automated systems. My journey in this domain has been marked by implementing cutting-edge technologies and guiding teams in adopting digital solutions that enhance productivity and reduce operational ",
//       name: "G. Lokesh",
//       designation: "Automation Training Specialist",
//       linkedin: "https://www.linkedin.com/in/md-ghouse",
//     },
//     {
//       image: image2,
//       text: "With over 5 years of experience in the field of Digital Facility Solutions, I specialize in transforming traditional industrial processes into smart, efficient, and automated systems. My journey in this domain has been marked by implementing cutting-edge technologies and guiding teams in adopting digital solutions that enhance productivity and reduce operational ",
//       name: "Riyaz Uddin",
//       designation: "Subject Matter Expert",
//       linkedin: "https://www.linkedin.com/in/saritha-komandla",
//     },
//     {
//       image: image3,
//       text: "With over 5 years of experience in the field of Digital Facility Solutions, I specialize in transforming traditional industrial processes into smart, efficient, and automated systems. My journey in this domain has been marked by implementing cutting-edge technologies and guiding teams in adopting digital solutions that enhance productivity and reduce operational ",
//       name: "MD. Ghouse",
//       designation: "Technical Trainer",
//       linkedin: "https://www.linkedin.com/in/thirumal-rao",
//     },
//   ];

//   const options = {
//     className: "owl-theme",
//     loop: true,
//     margin: 30,
//     nav: false,
//     autoplay: true,
//     autoplayTimeout: 3500,
//     autoplayHoverPause: true,
//     dots: true,
//     responsive: {
//       0: { items: 1 },
//       600: { items: 1 },
//       900: { items: 2 },
//       1200: { items: 3 },
//     },
//   };



//   return (



//     <div style={{
//       display: 'flex',
//       justifyContent: 'center',
//       alignItems: 'flex-start',
//       minHeight: '100vh',
//       padding: '40px 15px',
//       boxSizing: 'border-box',
//       padding:'62px'
//     }}>
//       <div style={{
//         width: '100%',
//         textAlign: 'center',
//         // paddingTop: '40px',
//         marginTop:'-330px'
//       }}>
//         <h1 style={{
//           fontFamily: 'Roboto, sans-serif',
//           fontWeight: 700,
//           fontSize: '48px',
//           marginBottom: '50px',
//           lineHeight: 1.2,
//           marginTop:"317px"
//         }}>
//           <span style={{ color: 'black' }}>What Our</span>{' '}
//           <span style={{ color: 'orange' }}>Trainers Say</span>
//         </h1>

//         <OwlCarousel {...options}>
//           {testimonials.map((testimonial, index) => (
//             <div
//               key={index}
//               className="testimonial-item"
//               style={{
//                 backgroundColor: '#fff',
//                 border: '2px solid #007bff', // Blue border
//                 padding: '30px 25px 30px',
//                 margin: 'auto',
//                 boxShadow: '0 4px 15px rgba(0,0,0,0.1)',
//                 borderRadius: '12px',
//                 position: 'relative',
//                 minHeight: '480px',
//                 display: 'flex',
//                 flexDirection: 'column',
//                 alignItems: 'center',
//                 justifyContent: 'flex-start',
//                 textAlign: 'justify', // Newspaper-style alignment
//               }}
//             >
//               <div style={{ position: 'relative', marginBottom: '60px', width: '130px', height: '130px' }}>
//                 <FaQuoteLeft
//                   style={{
//                     position: 'absolute',
//                     top: '8px',
//                     left: '35px',
//                     color: '#029aa0',
//                     fontSize: '22px',
//                     opacity: 0.3,
//                     zIndex: 0,
//                   }}
//                 />
//                 <FaQuoteLeft
//                   style={{
//                     position: 'absolute',
//                     top: '8px',
//                     right: '35px',
//                     color: '#029aa0',
//                     fontSize: '22px',
//                     opacity: 0.3,
//                     zIndex: 0,
//                     transform: 'scaleX(-1)',
//                   }}
//                 />
//                 <img
//                   src={testimonial.image}
//                   alt={testimonial.name}
//                   style={{
//                     width: '130px',
//                     height: '130px',
//                     borderRadius: '50%',
//                     border: '4px solid orange',
//                     objectFit: 'cover',
//                     position: 'relative',
//                     zIndex: 1,
//                   }}
//                 />
//               </div>

//               <p style={{
//                 fontSize: '1rem',
//                 color: '#333',
//                 lineHeight: '1.7',
//                 marginBottom: '20px',
//                 flexGrow: 1,
//                 padding: '0 10px', // Side padding inside the card
//               }}>
//                 {testimonial.text}
//               </p>

//               <div style={{
//                 display: 'flex',
//                 alignItems: 'center',
//                 justifyContent: 'center',
//                 gap: '12px',
//                 marginBottom: '8px',
//               }}>
//                 <a
//                   href={testimonial.linkedin}
//                   target="_blank"
//                   rel="noopener noreferrer"
//                   style={{ textDecoration: 'none' }}
//                   aria-label={`LinkedIn profile of ${testimonial.name}`}
//                 >
//                   <FaLinkedin style={{ fontSize: '22px', color: '#0077b5' }} />
//                 </a>
//                 <span style={{
//                   padding: '8px 18px',
//                   fontSize: '1rem',
//                   fontWeight: '700',
//                   color: '#fff',
//                   backgroundColor: 'orange',
//                   borderRadius: '50px',
//                   whiteSpace: 'nowrap',
//                 }}>
//                   {testimonial.name}
//                 </span>
//               </div>

//               <p style={{
//                 fontSize: '1.2rem',
//                 color: '#666',
//                 marginTop: '0',
//                 fontFamily: 'Roboto, sans-serif',
//                 fontWeight: 500,
//               }}>
//                 {testimonial.designation}
//               </p>
//             </div>
//           ))}
//         </OwlCarousel>
//       </div>

//     </div>

//   );
// };

// export default Testimonial;








// import React from 'react';
// import OwlCarousel from 'react-owl-carousel';
// import image1 from '../img/logo/New folder/IMG-20241127-WA0001.jpg';
// import image2 from '../img/logo/New folder/IMG-20241127-WA0003.jpg';
// import image3 from '../img/logo/New folder/IMG-20241127-WA0002 (1).jpg';
// import { FaLinkedin, FaQuoteLeft } from 'react-icons/fa';
// import 'owl.carousel/dist/assets/owl.carousel.css';
// import 'owl.carousel/dist/assets/owl.theme.default.css';

// const Testimonial = () => {
//   const testimonials = [
//     {
//       image: image1,
//       text: "As a trainer with 6 years of expertise in Virtual Robotics, my passion lies in bridging the gap between theoretical concepts and practical applications. My career has focused on developing robotic simulations, programming, and integrating advanced tools to design intelligent systems. I ensure that my trainees gain hands-on experience in creating real-world robotic models, preparing them for a future where automation and robotics redefine the industry landscape evolving field of robotics and ",
//       name: "G. Lokesh",
//       designation: "Automation Training Specialist",
//       linkedin: "https://www.linkedin.com/in/md-ghouse",
//     },
//     {
//       image: image2,
//       text: "With 15 years of extensive experience in Tool and Fixture Design, I bring a wealth of knowledge to every training session. My expertise lies in designing innovative tools and fixtures that align with industry standards, improving manufacturing accuracy and reducing downtime. My sessions are structured to provide insights into problem-solving, 2D layout studies, and quality control measures, ensuring that learners leave with practical skills they can immediately apply in their careers practical skills they can immediately",
//       name: "Riyaz Uddin",
//       designation: "Subject Matter Expert",
//       linkedin: "https://www.linkedin.com/in/saritha-komandla",
//     },
//     {
//       image: image3,
//       text: "With over 5 years of experience in the field of Digital Facility Solutions, I specialize in transforming traditional industrial processes into smart, efficient, and automated systems. My journey in this domain has been marked by implementing cutting-edge technologies and guiding teams in adopting digital solutions that enhance productivity and reduce operational costs. Training with me means diving deep into the core of digital facility design, understanding parametric modeling, and mastering innovative",
//       name: "MD. Ghouse",
//       designation: "Technical Trainer",
//       linkedin: "https://www.linkedin.com/in/thirumal-rao",
//     },
//   ];

//   const options = {
//     className: "owl-theme",
//     loop: true,
//     margin: 20,
//     nav: false,
//     autoplay: true,
//     autoplayTimeout: 4000,
//     autoplayHoverPause: true,
//     dots: true,
//     responsive: {
//       0: {
//         items: 1,
//       },
//       768: {
//         items: 2,
//       },
//       1024: {
//         items: 3,
//       },
//     },
//   };

//   return (
//     <div style={{
//       display: 'flex',
//       justifyContent: 'center',
//       alignItems: 'center',
//       minHeight: '100vh',
//       padding: '0 20px',
//     }}>
//       <div style={{
//         width: '100%',
//         maxWidth: '1200px',
//         textAlign: 'center',
//         padding: '50px 0',
//       }}>
//         <h1 style={{
//           fontFamily: 'Roboto',
//           fontWeight: 700,
//           fontSize: '36px',
//           marginBottom: '40px',
//         }}>
//           <span style={{ color: 'black' }}>What Our</span>{' '}
//           <span style={{ color: 'orange' }}>Trainers Say</span>
//         </h1>
//         <OwlCarousel {...options}>
//           {testimonials.map((testimonial, index) => (
//             <div key={index} className="testimonial-item" style={{
//               padding: '20px',
//               border: '1px solid #029aa0',
//               borderRadius: '10px',
//               boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
//               backgroundColor: '#fff',
//               display: 'flex',
//               flexDirection: 'column',
//               alignItems: 'center',
//               justifyContent: 'center',
//             }}>
//               <div style={{ position: 'relative', marginBottom: '30px' }}>
//                 <img
//                   src={testimonial.image}
//                   alt={testimonial.name}
//                   style={{
//                     width: '100px',
//                     height: '100px',
//                     borderRadius: '50%',
//                     border: '2px solid #029aa0',
//                     marginBottom: '10px',
//                   }}
//                 />
//               </div>
//               <p style={{
//                 fontSize: '14px',
//                 color: '#333',
//                 lineHeight: '1.6',
//                 marginBottom: '20px',
//               }}>
//                 {testimonial.text}
//               </p>
//               <div style={{
//                 display: 'flex',
//                 alignItems: 'center',
//                 justifyContent: 'center',
//                 marginBottom: '10px',
//               }}>
//                 <a href={testimonial.linkedin} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none', marginRight: '10px' }}>
//                   <FaLinkedin style={{ fontSize: '20px', color: '#0077b5' }} />
//                 </a>
//                 <span style={{
//                   display: 'inline-block',
//                   padding: '10px 15px',
//                   fontSize: '14px',
//                   fontWeight: 'bold',
//                   color: '#ffffff',
//                   backgroundColor: '#029aa0',
//                   borderRadius: '50px',
//                 }}>
//                   {testimonial.name}
//                 </span>
//               </div>
//               <p style={{
//                 fontSize: '16px',
//                 color: '#666',
//                 marginTop: '5px',
//               }}>
//                 {testimonial.designation}
//               </p>
//             </div>
//           ))}
//         </OwlCarousel>
//       </div>
//     </div>
//   );
// };

// export default Testimonial;

import React from 'react';
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import img1 from '../img/logo/New folder/IMG-20241127-WA0001.jpg';
import img2 from '../img/logo/New folder/IMG-20241127-WA0003.jpg';
import img3 from '../img/aaaservices/12_SARANYA.jpg';
import img4 from '../img/logo/New folder/IMG-20241127-WA0002 (1).jpg';


const offerings = [
  {
    image: img1,
    title: "G. Lokesh",
    subtitle:
      "It encompasses a comprehensive range of services aimed at providing innovative and efficient design solutions tailored to meet the unique needs of various industries.",
    link: "/MechinicalEngnneringdata",
    linkedin: "https://www.linkedin.com/in/glokesh",
    twitter: "https://twitter.com/glokesh",
  },
  {
    image: img2,
    title: "Riyaz Uddin",
    subtitle:
      "We provide comprehensive automated solutions to enhance AR and VR using robots and simulation tools to optimize BIW assembly like welding, handling & placement.",
    link: "/Automation",
    linkedin: "https://www.linkedin.com/in/riyazuddin",
    twitter: "https://twitter.com/riyazuddin",
  },
  {
    image: img3,
    title: "SARANYA",
    subtitle:
      "We transform traditional facilities into intelligent, data-driven environments with enhanced efficiency, security, and smart management using digital tech.",
    link: "/DigitalFaculty",
    linkedin: "https://www.linkedin.com/in/saranya",
    twitter: "https://twitter.com/saranya",
  },
  {
    image: img4,
    title: "MD. Ghouse",
    subtitle:
      "We transform traditional facilities into intelligent, data-driven environments with enhanced efficiency, security, and smart management using digital tech.",
    link: "/DigitalFaculty",
    linkedin: "https://www.linkedin.com/in/mdghouse",
    twitter: "https://twitter.com/mdghouse",
  },
];


const options = {
  className: "owl-theme",
  loop: true,
  margin: 20,
  nav: false,
  autoplay: true,
  autoplayTimeout: 3000,
  autoplayHoverPause: true,
  dots: false,
  responsive: {
    0: { items: 1 },
    600: { items: 2 },
    1000: { items: 4 },
  },
};

const OurOffering = () => {
  return (
    <div className="offering-wrapper">
       <p style={{
          textAlign: 'center',
          fontSize: '48px',
          fontWeight: 'bold',
          margin: '8px 0',
          marginTop:'-30px',
          fontFamily: '-apple-system, BlinkMacSystemFont, "SF Pro Text", "SF Pro Display", "Helvetica Neue", Helvetica, Arial, sans-serif'
        }}>
          <span style={{ color: 'white' }}>Our </span>
          <span style={{ color: 'rgb(247 148 29)' }}>Trainers</span>
        </p>

      <OwlCarousel {...options}>
        {offerings.map((item, index) => (
          <div className="offering-card" key={index}>
            <img src={item.image} alt={item.title} />
            <div className="overlay">
              <div className="text-container">
                <h3 className="heading-text">
                  <span className="gold-text">{item.title.split(' ')[0]}</span>{' '}
                  <span className="white-text">{item.title.split(' ').slice(1).join(' ')}</span>
                </h3>
               
   
    {offerings.map((item, index) => (
  <div key={index} className="offering-card">
    
    
    <p className="subtitle-text">{item.subtitle}</p>
    <div className="social-iconsyy">
      <a href={item.linkedin} target="_blank" rel="noopener noreferrer">
        <i className="fab fa-linkedin"></i>
      </a>
      <a href={item.twitter} target="_blank" rel="noopener noreferrer">
        <i className="fab fa-twitter"></i>
      </a>
    </div>
  </div>
))}

              </div>
            </div>
          </div>
        ))}
      </OwlCarousel>

      <style>{`
        .offering-wrapper {
          padding: 40px 20px;
          text-align: center;
          background-color: blue;
        }

        .offering-heading {
          font-size: 48px;
          font-weight: bold;
          color: Orange;
          margin-top:-10px;
        }

        .highlight {
          color: white;
        }

        .offering-card {
          position: relative;
          max-width: 280px;
          height: 320px;
          overflow: hidden;
          border-radius: 15px;
          box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
          cursor: pointer;
          margin: auto;
        }

        .offering-card img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: transform 0.3s ease;
        }

        .offering-card:hover img {
          transform: scale(1.05);
        }

        .overlay {
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          height: 100%;
          display: flex;
          align-items: flex-end;
          justify-content: flex-start;
          background: linear-gradient(to top, rgba(0, 0, 0, 0.85), rgba(0, 0, 0, 0.2));
          padding: 0 20px 20px;
          transform: translateY(40%);
          opacity: 0;
          transition: all 0.4s ease;
        }

        .offering-card:hover .overlay {
          transform: translateY(0%);
          opacity: 1;
        }

        .text-container {
          text-align: left;
        }

        .heading-text {
          font-size: 18px;
          font-weight: bold;
          margin-bottom: 20px;
          margin-top:150px;
          line-height: 1.3;
          text-shadow: 1px 1px 4px rgba(0,0,0,0.7);
        }

        .gold-text {
          color: gold;
        }

        .white-text {
          color: white;
        }

        .subtitle-text {
          font-size: 12px;
          line-height: 1.4;
          color: #ddd;
          margin: 0;
          text-shadow: 1px 1px 3px rgba(0,0,0,0.6);
        }



       .social-iconsyy {
  display: flex;
  justify-content: center; /* Horizontally center */
  align-items: center;
  margin: 8px 0;
}

.social-iconsyy a {
  margin: 0 10px;
  font-size: 18px;
  color:rgb(181, 124, 0); /* LinkedIn color by default */
  transition: color 0.3s ease;
}

.social-iconsyy a:hover {
  color: #1da1f2; /* Twitter color on hover */
}


        @media (max-width: 768px) {
          .offering-heading {
            font-size: 36px;
          }

          .offering-card {
            max-width: 240px;
            height: 280px;
          }

          .heading-text {
            font-size: 16px;
          }

          .subtitle-text {
            font-size: 11px;
          }
        }

        @media (max-width: 480px) {
          .offering-heading {
            font-size: 28px;
          }

          .offering-card {
            max-width: 200px;
            height: 240px;
          }

          .heading-text {
            font-size: 14px;
          }

          .subtitle-text {
            font-size: 10px;
          }
        }
      `}</style>
    </div>
  );
};

export default OurOffering;
